// extracted by mini-css-extract-plugin
export default {"heading":"sx-z","corrected":"tx-z","redirectVerbiageContainer":"ux-z","redirectVerbiageText":"vx-z"};